import CryptoJS from 'crypto-js';

// 签名密钥，需要与后端保持一致
const SECRET_KEY = 'yutong_vocab_signature_key_2024';

/**
 * 生成随机字符串
 * @param length 长度
 * @returns 随机字符串
 */
export function generateNonce(length: number = 16): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/**
 * 对象按键排序
 * @param obj 对象
 * @returns 排序后的对象
 */
export function sortObjectKeys(obj: any): any {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  const sortedKeys = Object.keys(obj).sort();
  const sortedObj: any = {};

  for (const key of sortedKeys) {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      sortedObj[key] = obj[key];
    }
  }

  return sortedObj;
}

/**
 * 对象转查询字符串
 * @param obj 对象
 * @returns 查询字符串
 */
export function objectToQueryString(obj: any): string {
  if (!obj || typeof obj !== 'object') {
    return '';
  }

  const pairs: string[] = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (value !== null && value !== undefined && value !== '') {
        pairs.push(`${key}=${value}`);
      }
    }
  }

  return pairs.join('&');
}

/**
 * 生成签名
 * @param method HTTP方法
 * @param url 请求URL
 * @param params 请求参数
 * @param timestamp 时间戳
 * @param nonce 随机数
 * @returns 签名字符串
 */
export function generateSignature(
  method: string,
  url: string,
  params: any,
  timestamp: string,
  nonce: string
): string {
  // 将参数按key排序后拼接
  const sortedParams = sortObjectKeys(params);
  const paramString = objectToQueryString(sortedParams);

  // 构建待签名字符串
  const signString = `${method}${url}${paramString}${timestamp}${nonce}${SECRET_KEY}`;

  // 生成MD5签名
  return CryptoJS.MD5(signString).toString();
}

/**
 * 为特定接口生成签名头
 * @param method HTTP方法
 * @param url 请求URL
 * @param params 请求参数
 * @returns 签名头对象
 */
export function generateSignatureHeaders(
  method: string,
  url: string,
  params: any
): { [key: string]: string } {
  // Date.now() 返回UTC时间戳，不受时区影响
  const timestamp = Math.floor(Date.now() / 1000).toString();
  const nonce = generateNonce();
  const signature = generateSignature(method, url, params, timestamp, nonce);

  return {
    'X-Request-Id': timestamp,
    'X-Request-Token': nonce,
    'X-Auth-Code': signature,
  };
}
